import {
  OWNER,
  VIEWER,
  PROFILE,
  SETTINGS,
  LIST,
  ITEM,
  ADD,
  EDIT,
  DELETE,
  SHARE,
  TRANSFER,
  CONNECTION_BUTTON,
  TOGGLE_VIEW,
  MAKE_WISH_TRUE,
  ROLLBACK_TRUE_WISH,
  GET_GENIES,
  UPDATE_AVATAR,
  UPDATE_CLOSE_FRIENDS
} from "constants/index"

export const ROLE_BASED_PERMISSIONS = {
  [OWNER]: {
    [PROFILE]: {
      [SETTINGS]: true,
      [EDIT]: true,
      [UPDATE_AVATAR]: true,
      [UPDATE_CLOSE_FRIENDS]: true
    },
    [LIST]: {
      [ADD]: true,
      [SHARE]: true,
      [EDIT]: true,
      [DELETE]: true,
      [TOGGLE_VIEW]: true
    },
    [ITEM]: {
      [TRANSFER]: true,
      [SHARE]: true,
      [EDIT]: true,
      [DELETE]: true,
      [MAKE_WISH_TRUE]: true,
      [ROLLBACK_TRUE_WISH]: true,
      [GET_GENIES]: true
    }
  },
  [VIEWER]: {
    [PROFILE]: {
      [CONNECTION_BUTTON]: true
    },
    [LIST]: {
      [SHARE]: true,
      [TOGGLE_VIEW]: true
    },
    [ITEM]: {
      [SHARE]: true,
      [GET_GENIES]: true
    }
  }
}
